














































import {
  Vue, Component, Prop, Watch, Mixins, Emit, ProvideReactive,
} from 'vue-property-decorator'
import {
  both, includes, filter, sortBy, sortWith, prop, descend, ascend,
} from 'ramda'
import dayjs from 'dayjs'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import { db } from '../../firebase/init'
import ViewUser from '../../components/users/ViewUser.vue'
import AddUser from '../../components/users/AddUser.vue'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import SingleSlide from '../../components/displays/SingleSlide.vue'
import AllSlides from '../../components/displays/AllSlides.vue'
import AllBoards from '../../components/displays/AllBoards.vue'
import SingleBoard from '../../components/displays/SingleBoard.vue'
import NewBoard from '../../components/displays/NewBoard.vue'
import NewSlide from '../../components/displays/NewSlide.vue'
import { DisplayBoardType, DisplaySlideType } from '../../types'

// Helper Functions
import UUID from '../../helpers/system/uuid'
import slug from '../../helpers/system/slug'

// Collections
import { DisplayBoardCollection, DisplaySlideCollection } from '../../helpers/collections'

// Filter Functions
// const isActive = (slide:DisplaySlideType) => (slide.active)
// const isInactive =  (slide:DisplaySlideType) => !(slide.active)
// const isManager = (slide:UserType) => (user.authTags && includes(`${store.getters.group}-manager`, user.authTags))
// const isEmployee = (slide:UserType) => (user.authTags && !includes(`${store.getters.group}-manager`, user.authTags))
// const isActiveManager = both(isActive, isManager)
// const isActiveEmployee = both(isActive, isEmployee)
const sortByNameAsc = sortWith([ascend(prop('name'))])
const sortByNameDes = sortWith([descend(prop('name'))])
const sortByDateAsc = sortWith([ascend(prop('created'))])
const sortByDateDes = sortWith([descend(prop('created'))])

@Component({
  components: {
    SingleSlide,
    AllSlides,
    NewSlide,
    AllBoards,
    SingleBoard,
    NewBoard,
  },
})

export default class DisplayBoards<T extends Vue> extends Mixins(MainMixin) {
  tabs = [{ title: 'Boards', value: 'boards' }, { title: 'Slides', value: 'slides' }]

  activeBoard:string = ''

  loading:boolean = false

  typeFilter = 'Image'

  orientationFilter = 'Portrait'

  activeSlide:DisplaySlideType|null = null

  section = 'all'

  showMap = {
    boards: 'one',
    slides: 'all',
  }

  get computedActiveBoard():DisplayBoardType|null {
    if (!this.activeBoard) {
      return null
    } return this.allBoards.find(board => board.id === this.activeBoard) || null
  }

  goBack() {
    if (this.$store.state.appStore.activeTab === 'boards') {
      if (this.section === 'singleBoard' || this.section === 'newBoard') {
        this.section = 'all'
        this.activeBoard = ''
      }
      if (this.section === 'singleSlide' || this.section === 'newSlide') {
        this.section = 'singleBoard'
        this.activeSlide = null
      }
    }
    if (this.$store.state.appStore.activeTab === 'slides') {
      console.log('going here', this.section)
      if (this.section === 'singleSlide' || this.section === 'newSlide') {
        this.section = 'all'
        this.activeBoard = ''
      }
    }
  }


  emitDisplay(x:string[]) {
    this.display(x[0], x[1])
  }

  display(tab:string = '', section:string = '', ud:boolean = false) {
    console.log('doing display: ', tab, section)
    if (tab && tab !== this.$store.state.appStore.activeTab) {
      EventBus.$emit('switch-tab', tab)
    } if (section) {
      this.section = section
    }
  }

  makeactive(slide:DisplaySlideType) {
    this.activeSlide = slide
  }

  makeBoardActive(board:DisplayBoardType|string) {
    console.log('making board active')
    if (typeof board === 'string') {
      this.activeBoard = board || ''
    } else {
      this.activeBoard = board.id || ''
    }
  }

  gotoboard(boardId:string = '', slideId:string = '') {
    if (boardId) {
      const board = this.allBoards.find(b => b.id === boardId)

      this.activeBoard = board ? board.id || '' : ''
    } if (slideId) {
      const slide = this.allSlides.find(s => s.id === slideId)
      this.activeSlide = slide || null
      this.showMap.slides = this.activeSlide ? 'one' : 'all'
    }
    // this.boardsTab()
  }

  sortItems = [
    { text: 'Created (Newest)', value: { name: 'sortByDateAsc', sortBy: sortByDateAsc } },
    { text: 'Created (Oldest)', value: { name: 'sortByDateDes', sortBy: sortByDateDes } },
    { text: 'Name (A-Z)', value: { name: 'sortByNameAsc', sortBy: sortByNameAsc } },
    { text: 'Name (Z-A)', value: { name: 'sortByNameDes', sortBy: sortByNameDes } },
  ]

  slidesSort = { name: 'sortByDateAsc', sortBy: sortByDateAsc }

  get activeTab() {
    return this.$store.state.appStore.activeTab
  }

  slidesActive = 'Active'

  allBoards:DisplayBoardType[] = []

  allSlides:DisplaySlideType[] = []

  @Watch('$store.state.appStore.activeTab')
  switchedTab(tab:string) {
    this.activeBoard = ''
    this.activeSlide = null
    if (tab === 'slides' || tab === 'boards') this.section = 'all'
    console.log('We Switched to: ', tab)
  }

  mounted() {
    this.$bind('allBoards', db.collection('displayBoards').where('location', 'in', [this.location, this.group]), { maxRefDepth: 0 })
    this.$bind('allSlides', db.collection('displaySlides').where('location', 'in', [this.location, this.group]))
  }

  // ===========================================
  // ===========================================


  userSearchField = ''

  selectedUser = ''

  showFilters = false

  // Dynamic Filters

  // created() {
  //   this.EventBus.$on('select-user', (id:string) => {
  //     console.log('going to activeuser: ', id)
  //   })
  // }
}
